<modal-container
  #modal
  [headerIconClass]="modalHeaderIcon"
  [headerTitle]="modalTitle"
  [modalHeaderBgColorClass]="
    type === 'in'
      ? 'header-class bg_green'
      : type === 'out'
        ? 'header-class bg_red'
        : type === 'transfer'
          ? 'header-class bg_orange'
          : ''
  "
  [modalBodyBgColorClass]="
    type === 'in' ? 'bg_green' : type === 'out' ? 'bg_red' : type === 'transfer' ? 'bg_orange' : ''
  "
  [modalFooterBgColorClass]="
    type === 'in' ? 'bg_green' : type === 'out' ? 'bg_red' : type === 'transfer' ? 'bg_orange' : ''
  "
  [isModalForTypeOut]="true"
>
  <ng-container class="modal-button-show">
    <btn
      *ngIf="isCreatingProduct && !hideButton"
      [classes]="['btn-second']"
      (onEvent)="showChildModal()"
      [icon]="'far-plus'"
      [label]="'product.create'"
      [title]="'product.create' | translate"
    ></btn>
    <btn
      *ngIf="isUpdatingProduct && !hideButton"
      [classes]="['btn-edit']"
      (onEvent)="showChildModal()"
      [icon]="'far-pencil'"
      [title]="'open' | translate"
    ></btn>
    <btn
      *ngIf="!isCreatingProduct && !isUpdatingProduct && !operationToUpdate && !hideButton"
      [classes]="['btn-second', 'btn-sm']"
      [icon]="'far-check'"
      [label]="'select'"
      (onEvent)="showChildModal()"
      [title]="'select' | translate"
    ></btn>
    <btn
      *ngIf="operationToUpdate"
      [classes]="['btn-edit']"
      (onEvent)="showChildModal()"
      [icon]="'far-pencil'"
      [title]="'open' | translate"
    ></btn>
  </ng-container>
  <ng-container class="modal-body-content">
    <div class="container-fluid pl-0 pr-0">
      <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
      <div class="stock-operation-card--content">
        <div class="card" style="padding: 26px 19px">
          <div class="form-operation-card" *ngIf="isCreatedProduct">
            <div class="row" *ngIf="type === 'in' || type === 'transfer'">
              <div class="col-12 col-sm-6">
                <form-row-select
                  [label]="'depot'"
                  [icon]="'far-industry'"
                  [isSelectDisabled]="true"
                  [options]="depots"
                  [(model)]="depotTo"
                >
                </form-row-select>
              </div>
              <div class="col-12 col-sm-6">
                <form-row-select
                  [label]="'supplier'"
                  [icon]="'far-truck'"
                  [(model)]="selectedSupplier"
                  [isSelectDisabled]="type === 'transfer'"
                  [options]="suppliers"
                >
                </form-row-select>
              </div>
            </div>

            <div class="row" *ngIf="(type === 'in' || type === 'transfer') && product?.enabledBatchExpiration">
              <div class="col-12 col-sm-6">
                <form-row-input
                  [label]="'product.batch'"
                  [icon]="'far-cubes'"
                  [(model)]="batch"
                  [inputDisabled]="type === 'transfer'"
                ></form-row-input>
              </div>
              <div class="col-12 col-sm-6">
                <form-row-input
                  [inputType]="'date'"
                  [label]="'product.expirationDate'"
                  [icon]="'far-clock'"
                  [inputDisabled]="type === 'transfer'"
                  [model]="expirationDate | fmtDate: 'yyyy-MM-dd'"
                  (modelChange)="expirationDate = $event"
                ></form-row-input>
              </div>
            </div>

            <div
              class="row stock-positions"
              *ngIf="companyUtil.arePositionsEnabled && (type === 'in' || type === 'transfer')"
            >
              <div class="col-12 col-sm-4 input-dash position-relative">
                <span class="stock-positions-absolute">{{ 'stock.positions' | translate }}</span>
                <form-row-input [label]="'row'" [icon]="'far-box'" [(model)]="position1"></form-row-input>
                <div class="align-self-center mt-2">-</div>
              </div>
              <div class="col-12 col-sm-4 input-dash">
                <form-row-input [label]="'aisle'" [icon]="'far-box'" [(model)]="position2"></form-row-input>
                <div class="align-self-center mt-2">-</div>
              </div>
              <div class="col-12 col-sm-4">
                <form-row-input [label]="'shelf'" [icon]="'far-box'" [(model)]="position3"></form-row-input>
              </div>
            </div>
            <div class="row mt-2" style="display: flex; justify-content: space-between">
              <div class="col-6" *ngIf="!operationToUpdate">
                <form-row-input
                  [inputType]="'number'"
                  [label]="'quantity'"
                  [icon]="'far-list'"
                  [model]="quantity"
                  [numberMax]="depotQuantity"
                  [numberMin]="inputQuantityMin"
                  (modelChange)="quantityChanged($event)"
                  [inputDisabled]="isQuantityLocked"
                  [appendBtnIcon]="isQuantityLocked ? 'far-lock' : 'far-unlock'"
                  [appendBtnClasses]="['btn-input']"
                  (onAppendBtnEvent)="!selectCustomPositions ? toggleLockQuantity() : ''"
                  [(appendCheckboxValue)]="selectCustomPositions ? null : isQuantityLocked"
                ></form-row-input>
                <form-row-toggle
                  *ngIf="type === 'out'"
                  class="align-self-center"
                  [label]="'selectCustomPositions'"
                  [model]="selectCustomPositions"
                  (modelChange)="selectCustomPositionChange($event)"
                  [classesString]="'text-nowrap'"
                ></form-row-toggle>
              </div>
              <div class="col-6" *ngIf="operationToUpdate">
                <form-row-input
                  [inputType]="'number'"
                  [label]="'quantity'"
                  [icon]="'far-list'"
                  [(model)]="quantity"
                ></form-row-input>
              </div>
              <div class="pl-4" *ngIf="type === 'out'">
                <div
                  class="img-card"
                  [photoGalleryGroup]="{ index: 1 }"
                  *ngFor="let img of product.images"
                  [photoGallery]="getThumbUrl(img, 'w2048wp')"
                  [photoGalleryCaption]="
                    img.product
                      ? img.product.name +
                        '<br>' +
                        (img.product.code ? ('modal-stock-operation-card.code' | translate) + img.product.code : '') +
                        '<br>' +
                        (img.product.ean ? ('modal-stock-operation-card.ean' | translate) + img.product.ean : '')
                      : ''
                  "
                >
                  <div class="img-container">
                    <div>
                      <img class="images-item-image" [src]="getThumbUrl(img)" [alt]="img.text" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex gap-05" *ngIf="type === 'in' || type === 'transfer'">
                <form-row-input
                  class="w-100"
                  [label]="'stock.operation.purchasePrice'"
                  [icon]="'far-money-bill'"
                  [(model)]="purchasePrice"
                  [replaceComma]="true"
                  [inputDisabled]="type === 'transfer'"
                ></form-row-input>
                <p class="my-auto pt-2 font-size-input">{{ product.purchaseCurrency | formatCurrencyWithoutPrice }}</p>
              </div>
            </div>
            <div class="table-responsive" *ngIf="type === 'out'">
              <table class="table m-0">
                <thead>
                  <tr>
                    <th class="text-center" *ngIf="companyUtil.arePositionsEnabled">
                      {{ 'product.position' | translate }}
                    </th>
                    <th *ngIf="type === 'out'" class="text-center">&nbsp;</th>
                    <ng-container *ngIf="product?.enabledBatchExpiration">
                      <th class="text-center">{{ 'product.expirationDate' | translate }}</th>
                      <th class="text-left">{{ 'product.batch' | translate }}</th>
                    </ng-container>
                    <th class="text-right">{{ 'max' | translate }}</th>
                    <th class="text-right">{{ 'product.unload.ks' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let productDepot of productDepots">
                    <td class="text-center no-hover" *ngIf="companyUtil.arePositionsEnabled">
                      {{ productDepot.position }}
                    </td>
                    <td *ngIf="type === 'out'" class="text-center no-hover">
                      <button
                        *ngIf="isProductDepotExpired(productDepot)"
                        type="button"
                        class="btn d-flex"
                        tooltip="{{ 'modal-stock-operation-card.expiration' | translate }}"
                        placement="left"
                        containerClass="expired-icon"
                      >
                        <img src="../../../../assets/img/icons/icon-expired-product.svg" alt="login image" />
                      </button>
                    </td>
                    <ng-container *ngIf="product?.enabledBatchExpiration">
                      <td class="text-center no-hover">
                        {{ productDepot.expirationDate ? (productDepot.expirationDate | fmtDate: 'dd.MM.yyyy') : '-' }}
                      </td>
                      <td class="text-left no-hover">{{ productDepot.batch ? productDepot.batch : '-' }}</td>
                    </ng-container>
                    <td class="text-right no-hover">{{ productDepot.quantityStock }}</td>
                    <td class="text-right no-hover" *ngIf="!selectCustomPositions">
                      {{ productDepot.amountToUnload }}
                    </td>
                    <td class="no-hover" *ngIf="selectCustomPositions">
                      <form-row-input
                        [icon]="'far-minus'"
                        [model]="productDepot.amountToUnload"
                        (modelChange)="amountToUnloadChanged($event, productDepot)"
                        [inputType]="'number'"
                        [numberMax]="productDepot.quantityStock"
                        [numberMin]="0"
                      ></form-row-input>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row" *ngIf="type === 'in' || type === 'transfer'">
              <div class="col-12">
                <form-row-textarea
                  #inputNote
                  [label]="'note'"
                  [icon]="'far-list'"
                  [(model)]="note"
                  [rows]="4"
                ></form-row-textarea>
              </div>
            </div>
          </div>
        </div>
        <alert [type]="'info'" *ngIf="resultMessage.length">
          {{ resultMessage }}
        </alert>
      </div>
    </div>
  </ng-container>
  <ng-container class="modal-footer-content">
    <button
      type="submit"
      class="btn-first"
      (click)="createProduct()"
      [title]="'product.create' | translate"
      *ngIf="isCreatingProduct && !isCreatedProduct"
      data-cy="submit"
    >
      <i class="far fa-check"></i>
      {{ 'product.create' | translate }}
    </button>
    <button
      type="submit"
      class="btn-first"
      (click)="updateProduct()"
      [title]="'product.update' | translate"
      *ngIf="isUpdatingProduct && !isCreatedProduct"
    >
      <i class="far fa-pencil"></i>
      {{ 'product.update' | translate }}
    </button>
    <button
      type="submit"
      [ngClass]="
        type === 'in'
          ? 'btn-first-green-inverted'
          : type === 'out'
            ? 'btn-first-red-inverted'
            : 'btn-first-orange-inverted'
      "
      (click)="createOperation()"
      [title]="
        type === 'in'
          ? ('product.load' | translate)
          : type === 'out'
            ? ('product.unload' | translate)
            : ('product.transfer' | translate)
      "
      *ngIf="isCreatedProduct"
      data-cy="stock-submit"
    >
      <i
        [ngClass]="type === 'in' ? 'far fa-layer-plus' : type === 'out' ? 'far fa-layer-minus' : 'far fa-exchange'"
      ></i>
      {{
        type === 'in'
          ? ('product.load' | translate)
          : type === 'out'
            ? ('product.unload' | translate)
            : ('product.transfer' | translate)
      }}
    </button>
  </ng-container>
</modal-container>
